import { useEffect, useRef } from 'react'
import { useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { loginRequest } from '../../authConfig'

// Invisible component — only call useMsal() here so it stays inside MsalProvider.
// Tries a silent SSO check on mount. Calls onSuccess(idToken) or onFail().
const SSOHandler = ({ onSuccess, onFail }) => {
  const { instance, accounts, inProgress } = useMsal()
  const attempted = useRef(false)

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return
    if (attempted.current) return

    // One-shot: right after an explicit (app-only) logout, skip silent SSO so
    // the still-active Okta/Microsoft session doesn't sign the user straight
    // back in. Show the login page instead.
    if (sessionStorage.getItem('sso_skip_silent')) {
      sessionStorage.removeItem('sso_skip_silent')
      attempted.current = true
      onFail()
      return
    }

    attempted.current = true

    const trySSO = async () => {
      try {
        let response
        if (accounts.length > 0) {
          // Accounts already in MSAL cache (e.g. after redirect callback)
          response = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          })
        } else {
          // Try silent login using existing Entra browser session
          response = await instance.ssoSilent(loginRequest)
        }
        onSuccess(response.idToken)
      } catch {
        // No active Entra session — user must click the login button
        onFail()
      }
    }

    trySSO()
  }, [inProgress, accounts])

  return null
}

export default SSOHandler
